/* eslint-disable no-undef */
import Axios from '../request';

export const NOTICE_GATE_ERROR_CODE = 60045;

export function noticesOf(action) {
  const notices = action && action.i9_notices;
  return Array.isArray(notices) ? notices.filter(Boolean) : [];
}

export function pendingNotices(action) {
  return noticesOf(action).filter((item) => !item.acknowledged);
}

export function isNoticeGateError(error) {
  const data = error && error.response && error.response.data;
  return Boolean(data) && data.error_code === NOTICE_GATE_ERROR_CODE;
}

export function acknowledgeNotice({
  digestKey, noticeKey, language, noticeVersion,
}) {
  const path = `${APIHOST}/v1/i9_form_submissions/${digestKey}/notices/${noticeKey}/acknowledge`;
  return Axios.post(path, { language, notice_version: noticeVersion });
}
